import { render, staticRenderFns } from "./NewDate.vue?vue&type=template&id=5c48027e&scoped=true"
import script from "./NewDate.vue?vue&type=script&lang=ts"
export * from "./NewDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48027e",
  null
  
)

export default component.exports